import type { ApiError } from '@/shared/api';

/**
 * Die Meldung zu einer abgelehnten Vergabe oder einem abgelehnten Entzug, auf Deutsch statt im
 * Wortlaut des Servers. Ein Konflikt heißt: das Konto hat sich zwischen Anzeige und Bestätigung
 * geändert — die Karte lädt danach neu und zeigt den Grund selbst.
 */
export function platformRoleChangeError(error: ApiError): string {
  switch (error.title) {
    case 'Auth.ReauthenticationFailed':
    case 'Auth.InvalidTwoFactorCode':
      return 'Passwort oder Code stimmt nicht. Bitte den nächsten Code der App abwarten.';
    case 'Auth.LockedOut':
      return 'Zu viele Fehlversuche — Ihr Konto ist für einige Minuten gesperrt.';
    default:
      return error.status === 409
        ? 'Das Konto hat sich gerade geändert. Die Karte zeigt jetzt den aktuellen Stand.'
        : (error.detail ?? error.title);
  }
}
